import { findTextOccurrences } from './wordDocumentSearch';

export interface DomOffsetMatch {
    startOffset: number;
    endOffset: number;
}

export function findDomOffsetMatches(root: HTMLElement, query: string, caseSensitive = false): DomOffsetMatch[] {
    const needle = query.trim();
    if (!needle) return [];

    const text = root.textContent ?? '';
    return findTextOccurrences(text, needle, caseSensitive).map((startOffset) => ({
        startOffset,
        endOffset: startOffset + needle.length,
    }));
}
